import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from '@mui/x-data-grid-pro';
import { fileNameHelper } from '../../../utils/fileNameHelper';
import SaveIcon from '@mui/icons-material/Save';
import { Button } from '@mui/material';
import { useSnackbar } from '../../../Context/SnackbarContext';
import { Icon } from '../../Atoms/Icon';

export interface CustomToolbarProps {
  showSearch: boolean;
  title: string;
  setFilterButtonEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  saveState: () => void;
  searchDebounceMs?: number;
}

export const CustomToolbar = ({
  showSearch,
  title,
  setFilterButtonEl,
  saveState,
  searchDebounceMs
}: CustomToolbarProps) => {
  const { setSnack } = useSnackbar();

  return (
    <GridToolbarContainer
      data-testid="grid-toolbar"
      sx={{ padding: '1rem 0rem 2rem 1rem' }}>
      {showSearch && (
        <GridToolbarQuickFilter
          data-testid="grid-toolbar-search"
          data-cy="data-grid-search"
          debounceMs={searchDebounceMs}
        />
      )}
      <div className={`${showSearch ? 'ml-auto' : ''}`}>
        <Button
          sx={{
            fontSize: '.8rem',
            textTransform: 'none'
          }}
          onClick={() => {
            saveState();
            setSnack({ message: 'Your table settings were saved successfully', type: 'success', open: true });
          }}
          color="secondary"
          startIcon={<SaveIcon />}>
          Save
        </Button>
        <GridToolbarColumnsButton
          slotProps={{
            button: {
              color: 'secondary',
              startIcon: <Icon type="columnsIcon" />,
              sx: { textTransform: 'none' }
            }
          }}
        />
        <GridToolbarFilterButton
          slotProps={{
            button: {
              color: 'secondary',
              sx: { textTransform: 'none' }
            }
          }}
          ref={setFilterButtonEl}
        />
        <GridToolbarDensitySelector
          slotProps={{
            button: {
              color: 'secondary',
              startIcon: <Icon type="densityIcon" />,
              sx: { textTransform: 'none' }
            }
          }}
        />
        <GridToolbarExport
          csvOptions={{
            fileName: `${fileNameHelper(title)}`
          }}
          slotProps={{
            button: {
              color: 'secondary',
              startIcon: <Icon type="exportIcon" />,
              sx: { textTransform: 'none' }
            }
          }}
        />
      </div>
    </GridToolbarContainer>
  );
};
